import { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/layers.css';
import './proto/seg-anim-v6.js'; // yan etkili: .seg/.tabs kayan pill (spec §3.1 — açılışta bir kez)
import { maintenanceAudience } from './app/maintenance/audience.js';
import { handlePreloadError } from './app/maintenance/chunk-reload.js';
import { MaintenanceLayer } from './app/maintenance/maintenance-layer.js';
import { matchPublicPath, PublicEntry } from './app/public-entry.js';
import { DentQueryProvider } from './data/query.js';
import { BootErrorBoundary } from './boot-error-boundary.js';
import { BootFallback } from './boot-fallback.js';

// `App` STATİK değil `React.lazy` ile yüklenir: aksi hâlde kabuğun tüm ağacı (shell-v3/v4,
// login-v6, mbys-v5, notifications-v4, tour-v6, ...) giriş modül grafiğine bağlı kalır ve
// `/randevu`ya gelen kimliksiz bir ziyaretçi bunu HİÇ kullanmasa da indirir — "ziyaretçi
// hiçbir zaman klinik kabuğunun kodunu yüklemez" sözü statik importla tutulamazdı (Task 13
// fix round 1).
const App = lazy(() => import('./app/App.js').then((m) => ({ default: m.App })));

const container = document.getElementById('app');
if (!container) {
  throw new Error('#app kök öğesi bulunamadı');
}

// Kabuksuz genel sayfalar (/randevu, /randevu/afis, /bekleme-salonu, /gizlilik ve hastanın
// belirteçli bağlantıları /odeme, /onam, /anket): App hiç çizilmeden önce yol denetlenir (spec §11). Her genel
// sayfa kendi parçasına gider (React.lazy, public-entry.tsx) — giriş paketine girmezler.
const publicRoute = matchPublicPath(window.location.pathname);

// index.html'in durağan başlığı nötrdür ("Diş Kliniği"): hastanın bağlantısı da bu dosyayla açılır
// ve bağlantı önizlemeleri JavaScript çalıştırmadan onu okur — satıcı adı hastaya giden hiçbir
// şeyde geçmez (2 Ekim 2026, ürün sahibi). Personel kabuğu kendi adını burada yazar; genel
// sayfalar kendi başlığını (klinik adıyla) yükleyince yazar.
if (publicRoute === null) document.title = 'DENT-OS';

// Güncellemeden önce açılmış bir sekme artık yayında olmayan bir parçayı ararsa bir kez yeni
// sürümle yenilenir (tasarım: 2026-09-22 bakım ekranı).
window.addEventListener('vite:preloadError', (event) => handlePreloadError(event));

createRoot(container).render(
  <BootErrorBoundary audience={publicRoute === null ? 'clinic' : 'public'}>
    <DentQueryProvider>
      <Suspense fallback={<BootFallback />}>
        {publicRoute === null ? <App /> : <PublicEntry route={publicRoute} />}
      </Suspense>
      {/* Kesinti, planlı bakım, duyuru şeridi ve yeni sürüm bildirimi: kabuğun da genel
          sayfaların da üstünde. Oturumlu personel App içinde "clinic" sayılır. */}
      <MaintenanceLayer
        audience={maintenanceAudience(window.location.pathname)}
        autoReloadOnUpdate={
          publicRoute?.kind === '/bekleme-salonu' || publicRoute?.kind === '/randevu/afis'
        }
      />
    </DentQueryProvider>
  </BootErrorBoundary>,
);
